import { ReactElement } from 'react'
import { Stack } from '@mui/material'
import OrganisationProjectFields from '../projectFields/OrganisationProjectFields'
import OrganisationSettingsSection from './OrganisationSettingsSection'

interface Props {
  readOnly: boolean
}

/** Projektkonfiguration (global Systemmanager): the project data fields and the Konfiguration. */
const OrganisationProjectConfiguration = ({ readOnly }: Props): ReactElement => (
  <Stack spacing={3}>
    <OrganisationProjectFields readOnly={readOnly} />
    <OrganisationSettingsSection readOnly={readOnly} />
  </Stack>
)

export default OrganisationProjectConfiguration
